import styled from 'styled-components';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import { colors } from '@/themes/colorsMapping';
import ProductHeader from '@/components/product/header/ProductHeader';
import ProductReviewMock from '@/components/product/shared/ProductReviewMock';

export const Wrapper = styled.div<{ isGallery?: boolean }>`
  height: 100%;
  width: 100%;
  overflow: hidden;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  @media (min-width: 800px) {
    justify-content: center;
    max-width: none !important;
    height: auto;
  }
  &:after {
    bottom: 0 !important;
    background-color: transparent !important;
  }
`;

export const Container = styled.div<{
  isEditingMode: boolean;
  isGallery: boolean;
  is3dModel: boolean;
  showStyleButton: boolean;
  increaseAspectRatio: boolean;
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  @media (max-width: 800px) {
    width: 100vw;
    margin-left: -20px;
    aspect-ratio: 0.9;
    height: ${(props) => (props.isGallery && props.is3dModel ? '100%' : '80vh')};
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 27px;
  background-color: ${colors.darkGray};
  margin: 0 10px;
`;

export const MainButtons = styled.div`
  display: flex;
  gap: 15px;
`;

export const BottomContainer = styled.div<{ isGallery?: boolean }>`
  width: 100%;
  background: ${({ isGallery }) =>
    isGallery
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 44%)'
      : ''};
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0;
  gap: 20px;
  position: relative;
  margin: ${({ isGallery }) => (isGallery ? '20px 0' : '0 0 15px 0')};

  @media (max-width: 799px) {
    border-radius: 0;
    height: ${({ isGallery }) => (isGallery ? 'auto' : '109px')};
    padding: ${({ isGallery }) => (isGallery ? '0' : '0 0 15px 0')};
    gap: 7px !important;
    position: ${({ isGallery }) => (isGallery ? 'relative' : 'absolute')};
    bottom: 0;
    margin: ${({ isGallery }) => (isGallery ? '10px 0 0 0' : '0')};
  }
`;

export const ActionLink = styled.button`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  align-items: center;
  flex-direction: ${({ theme }) => theme.slider.direction};
  min-width: 36px;
  position: relative;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 799px) {
    flex-direction: row;
    gap: 7px;
    font-size: 16px;
  }

  span {
    margin-left: ${({ theme }) => theme.slider.marginLeft}px;
  }

  .underline-link {
    margin: 0;
  }

  .underline-link:after {
    background-color: var(--color-primary);
  }

  &::after {
    content: '';
    position: absolute;
    top: -10px;
    right: -5px;
    bottom: -10px;
    left: -5px;
    z-index: -1;
  }
`;

export const ProductContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 0;
  bottom: 80px;
  z-index: 3;

  h1 {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }

  @media (min-width: 800px) {
    display: none;
  }
`;

export const ProductHeaderWithSize = styled(ProductHeader)`
  margin-bottom: 0;

  h1 {
    font-family: 'futura-pt', sans-serif;
    font-weight: 600;
    margin-right: 0;
    font-size: 22px;
  }
`;

export const ProductReviewMockStyled = styled(ProductReviewMock)`
  font-size: 14px;
  line-height: 14px;
  margin-top: 5px;

  svg {
    width: 65px;

    path:last-child {
      fill: ${colors.mediumGray};
      @media (max-width: 799px) {
        fill: ${colors.blackText};
      }
    }
  }
`;

export const ModelViewerWrapper = styled.div<{ isGallery?: boolean; galleryCurrentFrame?: number }>`
  width: 100%;
  height: 100%;

  @media (min-width: 799px) {
    overflow: hidden;
    border-radius: 15px;
    height: auto !important;
    aspect-ratio: 0.9;
    background-color: ${({ isGallery }) => (isGallery ? colors.gray : 'transparent')};
  }

  & > div {
    height: ${({ isGallery }) => (isGallery ? '100%' : '500px')};
    @media (min-width: 799px) {
      height: 100%;
    }

    model-viewer {
      width: ${({ isGallery }) => (isGallery ? '100%' : '106%')} !important;
      height: ${({ isGallery }) => (isGallery ? '100%' : '106% !important')};
      max-height: ${({ isGallery }) => (isGallery ? '100%' : '500px')};
      align-self: flex-start;
      @media (min-width: 800px) {
        align-self: center;
        width: 100% !important;
        height: 100% !important;
        max-height: none !important;
      }
    }
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${colors.divider};
  margin: 0 10px;
`;
